export default [
  {
    label: 'Add matter ',
    target: '?wizard=ExistingClient-NewMatter&stage=matter&step=matter-details',
    requiredMenuItemId: 1210
  },
  {
    label: 'Add matter with conflict search',
    target: '?wizard=COIS-ExistingClient-NewMatter&stage=conflict&step=introduction',
    requiredMenuItemId: 1300
  },
  {
    label: 'Edit client',
    target: `/case-management/clients/client-detail/edit-client`,
    appendClientMatterNoToTarget: true,
    requiredMenuItemId: 1211
  },
  {
    label: 'Client workspace',
    target: '/case-management/clients/client-workspace',
    menuItemId: 1100,
    requiredMenuItemId: 1100,
    appendClientMatterNoToTarget: true
  }
]
